export const defaultPrimaryColors = {
  action: "#000000",
  main: "#012659",
  mainText: "#000000",
  secondaryText: "#ffffff",
  divider: "#ffffff",
  stepperText: "#ffffff",
  buttonText: "#ffffff",
  icon: "#012659",
  iconBg: "#2b6777",
  background: "#ffffff",
  additionalInfo: "#148e2a",
  totalPrice: "#012659",
  button: "#2c3070",
  addButton: "#148e2a",
  decButton: "#2c3070",
  qtyBackground: "#F4F4F4",
  cartIconEmpty: "#012659",
  cartIconFilled: "#528d36",
  cartIconBackground: "#ffffff",
  cartBadge: "#b30000",
  cartBackground: "#ffffff",
  cartBorders: "#012659",
  dateRangeBgFrom: "#0454c2",
  dateRangeBgTo: "#012659",
  dateRangeBgComplete: "#148e2a",
  dateRangeTitle: "#000000",
  dateRangeBg: "#ffffff",
  providerSelectBg: "#ffffff",
  productCardBg: "transparent",
  dialogBackground: "#ffffff",
  filterSelected: "#012659",
  filterOption: "#808080",
  extraFields: "#808080",
  rescheduleAlertBg: "##e8f4fd",
  serviceProviderBg: "transparent",
  stepperBg: "transparent",
  stepperBgActive: "transparent",
  stepperActiveText: "rgba(0,0,0,0.90)",
  stepperInactiveText: "rgba(0,0,0,0.25)",
  stepperActiveValue: "#ffffff",
  stepperInactiveValue: "rgba(0,0,0,0.45)",
  stepperInactiveAvatar: "rgba(0,0,0,0.15)",
  stepperCompleted: "#ffffff",
  reservedButtonColor: "#528d36",
  mobileStepper: "rgba(0,0,0,0.85)",
  mobileStepperProgress: "#528d36",
};

export const defaultSecondaryColors = {
  main: "#528d36",
  reservedButtonColor: "#012659",
  stepper: "#b6b6b6",
  stepperText: "#000000",
  stepperIndicatorText: "#ffffff",
  background: "#ffffff",
  filterBackground: "#efefefef",
  text: "#808080",
  serviceProviderBg: "#f7f7f7",
};
